
/* =====================================================
   EYAL APP - PRODUCT CATEGORIES
   USE THIS LIST EVERYWHERE
===================================================== */

export const PRODUCT_CATEGORIES = [
  {
    name: "Groceries",
    icon: "🛒",
  },
  {
    name: "Electronics",
    icon: "📱",
  },
  {
    name: "Fashion",
    icon: "👕",
  },
  {
    name: "Footwear",
    icon: "👟",
  },
  {
    name: "Furniture",
    icon: "🛋️",
  },
  {
    name: "Hardware",
    icon: "🔧",
  },
  {
    name: "Medical",
    icon: "💊",
  },
  {
    name: "Stationery",
    icon: "✏️",
  },
  {
    name: "Jewellery",
    icon: "💍",
  },
  {
    name: "Mobile",
    icon: "📱",
  },
  {
    name: "Daily Needs",
    icon: "🛍️",
  },
  {
    name: "Personal care",
    icon: "🧴",
  },
  {
    name: "Restaurant",
    icon: "🍽️",
  },
  {
    name: "Bakery",
    icon: "🥐",
  },
  {
    name: "Others",
    icon: "📦",
  },
];